export const desktopSize = 1024;